module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_38.761c9fab.jpeg";